export const Accordion = () => {
    return {
        selected: false,

        init () {
        },

        open(index = true) {
            console.log(index);
            this.selected = this.isOpen(index) ? false : index;
        },

        isOpen(index = true) {
            return this.selected === index;
        }
    }
}
